/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PutOrganizationsIdMutationRequest,
  PutOrganizationsIdMutationResponse,
  PutOrganizationsIdPathParams,
  PutOrganizationsId400,
  PutOrganizationsId401,
  PutOrganizationsId403,
} from "../types/PutOrganizationsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const putOrganizationsIdMutationKey = () =>
  [{ url: "/organizations/:id" }] as const;

export type PutOrganizationsIdMutationKey = ReturnType<
  typeof putOrganizationsIdMutationKey
>;

/**
 * @description Только Owner и Admin могут редактировать организацию.
 * @summary Обновление информации об организации
 * {@link /organizations/:id}
 */
export async function putOrganizationsId(
  id: PutOrganizationsIdPathParams["id"],
  data?: PutOrganizationsIdMutationRequest,
  config: Partial<RequestConfig<PutOrganizationsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutOrganizationsIdMutationResponse,
    ResponseErrorConfig<
      PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
    >,
    PutOrganizationsIdMutationRequest
  >({
    method: "PUT",
    url: `/organizations/${id}`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function putOrganizationsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutOrganizationsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putOrganizationsIdMutationKey();
  return mutationOptions<
    ResponseConfig<PutOrganizationsIdMutationResponse>,
    ResponseErrorConfig<
      PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
    >,
    {
      id: PutOrganizationsIdPathParams["id"];
      data?: PutOrganizationsIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putOrganizationsId(id, data, config);
    },
  });
}

/**
 * @description Только Owner и Admin могут редактировать организацию.
 * @summary Обновление информации об организации
 * {@link /organizations/:id}
 */
export function usePutOrganizationsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PutOrganizationsIdMutationResponse>,
      ResponseErrorConfig<
        PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
      >,
      {
        id: PutOrganizationsIdPathParams["id"];
        data?: PutOrganizationsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutOrganizationsIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putOrganizationsIdMutationKey();

  const baseOptions = putOrganizationsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PutOrganizationsIdMutationResponse>,
    ResponseErrorConfig<
      PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
    >,
    {
      id: PutOrganizationsIdPathParams["id"];
      data?: PutOrganizationsIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PutOrganizationsIdMutationResponse>,
    ResponseErrorConfig<
      PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
    >,
    {
      id: PutOrganizationsIdPathParams["id"];
      data?: PutOrganizationsIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PutOrganizationsIdMutationResponse>,
    ResponseErrorConfig<
      PutOrganizationsId400 | PutOrganizationsId401 | PutOrganizationsId403
    >,
    {
      id: PutOrganizationsIdPathParams["id"];
      data?: PutOrganizationsIdMutationRequest;
    },
    TContext
  >;
}
